import { PERMISSIONS, ROLE_KEYS, type Role } from '@/types';

const all = Object.values(PERMISSIONS);

export const mockRoles: Role[] = [
  {
    id: 'role_super_admin',
    key: ROLE_KEYS.SUPER_ADMIN,
    name: 'Super Admin',
    description: 'Full system access',
    permissions: all,
    isSystem: true,
    createdAt: new Date().toISOString(),
  },
  {
    id: 'role_admin',
    key: ROLE_KEYS.ADMIN,
    name: 'Admin',
    description: 'Administrative access',
    permissions: all.filter((p) => p !== PERMISSIONS.SETTINGS_MANAGE),
    isSystem: true,
    createdAt: new Date().toISOString(),
  },
  {
    id: 'role_manager',
    key: ROLE_KEYS.MANAGER,
    name: 'Manager',
    description: 'Team management',
    permissions: [
      PERMISSIONS.DASHBOARD_VIEW,
      PERMISSIONS.DASHBOARD_EDIT,
      PERMISSIONS.WIDGET_CREATE,
      PERMISSIONS.WIDGET_EDIT,
      PERMISSIONS.REPORTS_VIEW,
    ],
    isSystem: true,
    createdAt: new Date().toISOString(),
  },
  {
    id: 'role_user',
    key: ROLE_KEYS.USER,
    name: 'User',
    description: 'Standard user',
    permissions: [PERMISSIONS.DASHBOARD_VIEW, PERMISSIONS.REPORTS_VIEW],
    isSystem: true,
    createdAt: new Date().toISOString(),
  },
];
